import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// SCROLL TO TOP ON LOAD
export default function useScrollToTopReact() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
